import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Download, User } from 'lucide-react';
import { AnimatedSection, staggerContainer, staggerItem } from './AnimatedSection';
export function HowItWorks() {
  return <AnimatedSection className="py-8 sm:py-24 bg-slate-50" data-id="element-15502">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15503">
        <div className="text-center mb-6 sm:mb-16" data-id="element-15504">
          <h2 className="text-lg sm:text-3xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-15505">
            Как это работает
          </h2>
          <p className="text-xs sm:text-lg text-slate-500" data-id="element-15506">
            Три простых шага к пониманию себя
          </p>
        </div>

        {/* Mobile: compact horizontal steps */}
        <div className="sm:hidden space-y-3" data-id="element-15507">
          {[{
          step: '01',
          title: 'Введите данные',
          desc: 'Дата, время и место рождения.',
          icon: <FileText className="w-5 h-5" data-id="element-15508" />,
          bg: 'bg-indigo-50 text-indigo-600'
        }, {
          step: '02',
          title: 'Получите отчёт',
          desc: 'Мгновенный PDF с расшифровкой.',
          icon: <Download className="w-5 h-5" data-id="element-15509" />,
          bg: 'bg-amber-50 text-amber-600'
        }, {
          step: '03',
          title: 'Консультация',
          desc: 'Персональная консультация с астрологом.',
          icon: <User className="w-5 h-5" data-id="element-15510" />,
          bg: 'bg-emerald-50 text-emerald-600'
        }].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white rounded-xl p-3 border border-slate-100" data-id="element-15511">
              <div className={`w-10 h-10 rounded-xl ${item.bg} flex items-center justify-center flex-shrink-0`} data-id="element-15512">
                {item.icon}
              </div>
              <div data-id="element-15513">
                <div className="flex items-center gap-2" data-id="element-15514">
                  <span className="text-[10px] font-bold text-slate-400 tracking-wider" data-id="element-15515">
                    {item.step}
                  </span>
                  <h3 className="text-sm font-bold text-slate-900" data-id="element-15516">
                    {item.title}
                  </h3>
                </div>
                <p className="text-xs text-slate-500" data-id="element-15517">{item.desc}</p>
              </div>
            </div>)}
        </div>

        {/* Desktop: centered steps */}
        <motion.div className="hidden sm:grid md:grid-cols-3 gap-8 relative" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} data-id="element-15518">
          <div className="hidden md:block absolute top-16 left-[20%] right-[20%] h-px bg-slate-200 z-0" data-id="element-15519" />
          {[{
          step: '01',
          title: 'Введите данные',
          desc: 'Укажите дату, время и место рождения для точного расчёта.',
          icon: <FileText className="w-7 h-7" data-id="element-15520" />,
          bg: 'bg-indigo-50 text-indigo-600'
        }, {
          step: '02',
          title: 'Получите отчёт',
          desc: 'Мгновенно скачайте подробный PDF с расшифровкой вашей карты.',
          icon: <Download className="w-7 h-7" data-id="element-15521" />,
          bg: 'bg-amber-50 text-amber-600'
        }, {
          step: '03',
          title: 'Консультация',
          desc: 'Закажите персональную консультацию для ответов на вопросы.',
          icon: <User className="w-7 h-7" data-id="element-15522" />,
          bg: 'bg-emerald-50 text-emerald-600'
        }].map((item, i) => <motion.div key={i} variants={staggerItem} className="relative z-10 flex flex-col items-center text-center" data-id="element-15523">
              <div className={`w-20 h-20 rounded-2xl ${item.bg} flex items-center justify-center mb-6 shadow-sm`} data-id="element-15524">
                {item.icon}
              </div>
              <div className="text-xs font-bold text-slate-400 mb-2 tracking-[0.2em]" data-id="element-15525">
                {item.step}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-15526">
                {item.title}
              </h3>
              <p className="text-slate-500 max-w-xs" data-id="element-15527">{item.desc}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </AnimatedSection>;
}